import { SearchOrderItemBinded, SearchOrderWithProducts } from '../../models/Orders_v2';
import { BillConceptos, BillConceptTax } from '../../models/Factura';

export function orderToConceptos(
    products: SearchOrderWithProducts['products'],
    itemBindersMap: { [asin: string]: SearchOrderItemBinded }
): BillConceptos[] {
    return products.reduce((p, c) => {
        const binder = itemBindersMap[c.item.product.asin];
        const taxes = binder.binder.taxes;
        const iva = taxes.find(t => t.type === 'iva');
        const ieps = taxes.filter(t => t.type === 'ieps');
        const iepsTasa = ieps.reduce((_p, t) => _p += (t.tasa || 0), 0);
        const subtotalPreIeps = Math.round(((c.item.product.price.unitPrice.amount) / (1 + (iva?.tasa || 0))) * 100) / 100;
        const subtotal = Math.round((subtotalPreIeps / (1 + iepsTasa)) * 100) / 100;

        const conceptoBase: BillConceptos = {
            claveProdServ: binder.binder.claveProdServ,
            claveUnidad: binder.binder.claveUnidad,
            cantidad: c.item.quantityOrdered,
            descripcion: c.item.product.title,
            valorUnitario: subtotal,
            impuestos: taxes.map(t => {
                const taxProt: BillConceptTax = {
                    type: t.type,
                    retencion: t.retencion || false,
                    exento: t.exento || false
                };
                if (t.tasa !== undefined) {
                    taxProt.tasa = t.tasa;
                }
                return taxProt;
            })
        };

        p.push(conceptoBase);
        return p;
    }, [] as BillConceptos[]);
}
